import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {HintDto} from "@/store/task/types";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";

export class TizerPanel extends VerticalStandardPanel {

    private static COLORS: string[] = ['#ffca3a', '#bcff5c'];

    private onAcceptCallback!: (show: boolean) => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, hint: HintDto, onAcceptCallback: (show: boolean) => unknown) {
        super(scene, canvas, hint.histroryTitle);

        this.onAcceptCallback = onAcceptCallback;

        let self = this;
        let teacherImage = SpriteUtils.addImage(this.scene, -200, this.getXButtonY() + 115, Keys.HINTER).setOrigin(0, 0)
            .setOrigin(0, 0);

        let i = 0;
        let color: () => string = () => {
            ++i;
            i = i % 2;
            return TizerPanel.COLORS[i];
        }

        let titleSize = 18;
        let blockSize = 14;

        if (hint.history3 && hint.history3 !== '' || hint.advise3 && hint.advise3 !== '') {
            titleSize -= 1;
            blockSize -= 1;
        }

        let histroryTitle = TextUtils.addTextAdvanced(scene, hint.histroryTitle, 0, this.getXButtonY() + 84,
            color(), titleSize, 'bold', 365, 'center', 2, Fonts.ARIAL_MT).setOrigin(0.5, 0);

        let yy = histroryTitle.y;

        let history1 = TextUtils.addTextAdvanced(scene, hint.history1, -85, yy / CU.S + 45,
            color(), blockSize, 'normal', 300, 'left', 2, Fonts.ARIAL_MT).setOrigin(0, 0);
        yy = history1.getBottomCenter().y!;

        let history2 = TextUtils.addTextAdvanced(scene, hint.history2, -85, yy / CU.S + 20,
            color(), blockSize, 'normal', 300, 'left', 2, Fonts.ARIAL_MT).setOrigin(0, 0);
        yy = history2.getBottomCenter().y!;

        if (hint.history3 && hint.history3 !== '') {
            let history3 = TextUtils.addTextAdvanced(scene, hint.history3, -195, yy / CU.S + 20,
                color(), blockSize, 'normal', 410, 'left', 2, Fonts.ARIAL_MT).setOrigin(0, 0);
            yy = history3.getBottomCenter().y!;
            this.add(history3);
            yy = history3.getBottomCenter().y!;

            if (hint.advise1 && hint.advise1 !== '') {
                let advise1 = TextUtils.addTextAdvanced(scene, hint.advise1, -195, yy / CU.S + 20,
                    color(), blockSize, 'normal', 410, 'left', 2, Fonts.ARIAL_MT).setOrigin(0, 0);
                yy = advise1.getBottomCenter().y!;
                this.add(advise1);
            }
        }

        this.add([teacherImage, histroryTitle, history1, history2]);

        this.addCustomButton(-90, this.getCloseButtonY() + 30, Tr('close').toUpperCase(),
            Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => this.onAcceptCallback(false));

        this.addCustomButton(90, this.getCloseButtonY() + 30, Tr('watch').toUpperCase(),
            Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => this.onAcceptCallback(true));
    }

}
